<template>
  <!-- 小组  王江龙 20200226 -->
 <div class="group">
   <div class="content" v-if="tableData && tableData.length">
     <img style="display: block;width: 10%;margin: 0 auto"  src="./img/jingyingxiaozu@3x.png" >
     <p>{{tableData[0].teamName}}</p>
     <p style="font-size: 16px;font-weight: 400">小组标语：{{tableData[0].title}}</p>
     <el-table
       :data="tableData"
       maxHeight="400"
       style="width: 100%">
       <el-table-column
         width="50">
         <template>
           <img style="width: 14px;margin-top: 9px;" src="./img/jing@3x.png" >
         </template>
       </el-table-column>
       <el-table-column
         prop="studentName"
         label="成员姓名">
       </el-table-column>
       <el-table-column
         prop="stationName"
         label="岗位">
         <template slot-scope="scope">
           <div style="color: #5397F7" v-for="item in scope.row.stations" :key="item.id">{{item.postName}}</div>
         </template>
       </el-table-column>
       <el-table-column
         prop="mobile"
         label="联系方式">
       </el-table-column>
     </el-table>
     <p>岗位制度</p>
     <div class="textContent">
       <ul>
          <li v-for="(item,i) in postList" :key="i">
            <span style="color: #5397F7">{{item.name}}{{item.remark?'：':''}}</span>{{item.remark}}
          </li>
        </ul>
     </div>
   </div>
 </div>
</template>

<script>
  import * as courseApi from '../../../../../api/courseApi'
  import * as api from '../../../../../api/statisticsApi'
    export default {
      name: "index.vue",
      data(){
        return {
          tableData: [],
          courseId:this.$route.query.id,
          classId:this.$route.query.classId,
          subjectId:'',
          postList: []
        }
      },
      created(){
        this.init()
      },
      methods:{
        init(){
          this.getClassInfo();
        },
        getClassInfo(){//根据班级id查询信息
          courseApi.getClassInfo(this.classId).then(rs=>{
            if(rs.code === "0"){
              this.subjectId = rs.data.subjectId;
            }else{
              this.$messageError(rs.msg)
            }
          }).then(()=>{
            this.getXiaoZu()
            this.getPostInfo()
          })
        },
        getXiaoZu(){//获取小组信息
          let params = {
            courseId:this.courseId,
            classId:this.classId,
          }
          api.getMyTeam(params).then(res => {
            if (res.code == 0) {
              this.getStation(res.data);
            }else{
              this.$messageError(res.msg)
            }
          })
          .catch(error => {
            return error;
          });
        },
        getStation(arr){// 获取岗位列表，对应的插入小组数据中
          api.FindStationBySubjectId(this.subjectId).then(res => {
            if (res.code == 0) {
              [].forEach.call(arr, item =>{
                if(item.stations && item.stations.length){
                  [].forEach.call(item.stations, items =>{
                    [].forEach.call(res.data, itemt =>{
                      if (items.stationId == itemt.id){
                        this.$set(items ,'postName', itemt.name)
                      }
                    })
                  })
                }
              });
              this.tableData = arr;
            }else{
              this.$messageError(res.msg)
            }
          }).catch(error => {
            return error;
          });
        },
        getPostInfo(){//岗位制度
					let params = {
						courseId:this.courseId,
						classId:this.classId,
					}
          api.FindStationByClassId(params).then(rs=>{
            if(rs.code==0){
              this.postList = rs.data
            }else{
              this.$messageError(rs.msg)
            }
          })
        },
      }
    }
</script>

<style  scoped lang="scss">
  .group{
    width: 100%;
    height: 100%;
    .content{
      width: 70%;
      height: 80%;
      overflow-y: auto;
      padding-top: 1%;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 8px;
      box-shadow: 0 0 8px 8px #72A2EA;
      background: #E9F1FD;
      p{
        font-size: 17px;
        text-align: center;
        font-weight: 600;
        color: #5397F7;
        padding: 10px 0 ;
      }

    }
    /deep/ .el-table{
      width: 80% !important;
      margin:0 auto;
      border-radius: 5px;
      .has-gutter{
        th{
          background: #5397F7;
        }
        .cell{
          color: white;
        }
      }
    }
    .textContent{
      width: 80%;
      margin: 0 auto 24px;
      background: #fff;
      border-radius: 5px;
      min-height: 70px;
      padding: 20px 40px;
      box-sizing: border-box;
      ul{
        li{
          font-size:14px;
          font-weight:400;
          line-height:25px;
          color:rgba(51,51,51,1);
          margin-bottom: 16px;
          span{
            color: #5397F7;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/group/index.vue